module.exports = __webpack_public_path__ + "img/bgDrawer.576bc950.jpg";